module.exports = __webpack_public_path__ + "static/media/open.f73c74ce.svg";